import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../services/Api';
import { authHeader } from '../../services/auth-header';
import Swal from 'sweetalert2';
import PPSIView from './PumpSpareInternational/View';
import PRAMDView from './AraiManufacturing/View';

function PRView() {
  const navigate = useNavigate();
  const { pointindex, id } = useParams();

  const [purchasereturntype, setPurchasereturntype] = useState('');
  const [purchasereturncategory, setPurchasereturncategory] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}purchaseReturn/findById/${id}`, {
          headers: authHeader(),
        });
        setPurchasereturntype(response.data.purchasereturntype);
        setPurchasereturncategory(response.data.purchasereturncategory);
      } catch (err) {
        console.error('Error fetching data:', err);
        setError('Failed to load purchase return data.');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const renderPageDisplay = () => {
    if (purchasereturntype === 'Pump Spare' && purchasereturncategory === 'International') {
      return <PPSIView />;
    } else if (purchasereturntype === 'Manufacturing') {
      return <PRAMDView />;
    }
    return null;
  };

  const handleDelete = async () => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(`${BASE_URL}purchaseReturn/delete/${id}`, {
          headers: authHeader(),
        });
        if (response.data.length === 0) {
          Swal.fire('Warning', 'PO is present in another module. Delete operation has been cancelled.', 'warning');
        } else {
          Swal.fire('Deleted!', 'Deleted successfully.', 'success');
          navigate(`/prindex/${pointindex}`);
        }
      } catch (error) {
        Swal.fire('Error', error.response?.data || 'An error occurred', 'error');
      }
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="error-message">{error}</div>;

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>VIEW PURCHASE RETURN</h6>
          <div>
            <strong>Type:</strong> {purchasereturntype} | <strong>Category:</strong> {purchasereturncategory}
          </div>
          <div className="view-buttons">
            {/* Uncomment if delete functionality is needed */}
            {/* <button className="button-70" onClick={handleDelete}>DELETE</button> */}
            {/* Uncomment and update if you want an edit page */}
            {/* <Link to={`/prEdit/${id}/${pointindex}`}>
              <button className="button-70">EDIT</button>
            </Link> */}
            <Link to={`/prindex/${pointindex}`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        {renderPageDisplay()}

      </Card>
    </div>
  );
}

export default PRView;
